<ng-template #noSprintMess>
  <div class="text-center">Nessuno sprint in corso</div>
</ng-template>

<div *ngIf="errorMessage" class="text-danger text-end">
  <p class="m-0">{{ errorMessage }}</p>
</div>

<div
  class="nz-table-wrapper scrum-table"
  *ngIf="data[0]?.capacity; else noSprintMess">
  <nz-table
    #columnTable
    [nzData]="data"
    [nzBordered]="false"
    [nzShowPagination]="false"
    [nzScroll]="{ x: '900px' }">
    <thead>
      <tr>
        <th
          nzLeft
          [nzWidth]="'200px'"
          class="table-color d-flex justify-content-center align-items-center border-0 p-2"
          id="sprint-column">
          <!-- indietro -->
          <button
            nz-button
            nzType="text"
            class="p-0 pe-2 bg-transparent d-flex align-items-center"
            [disabled]="isLeftButtonDisabled()"
            (click)="selectPreviousSprint()">
            <span nz-icon nzType="caret-left" nzTheme="outline"></span>
          </button>

          <!-- Select sprint -->
          <nz-select
            nzShowSearch="true"
            nzServerSearch="false"
            [nzAllowClear]="false"
            (nzOnSearch)="filteredSprints($event)"
            nzPlaceHolder="Cerca sprint..."
            [(ngModel)]="selectedSprint"
            (ngModelChange)="changeSprint($event)"
            nzNotFoundContent="Nessuno sprint corrispondente"
            [nzOptionOverflowSize]="5">
            <nz-option
              *ngFor="let sprint of filteredSprints()"
              [nzLabel]="'Sprint ' + sprint.number"
              [nzValue]="sprint">
            </nz-option>
          </nz-select>

          <!-- avanti -->
          <button
            nz-button
            nzType="text"
            class="p-0 ps-2 bg-transparent d-flex align-items-center"
            [disabled]="isRightButtonDisabled()"
            (click)="selectNextSprint()">
            <span nz-icon nzType="caret-right" nzTheme="outline"></span>
          </button>
        </th>

        <!-- Colonne con le date -->
        <th
          *ngFor="let day of data[0].capacity"
          [nzWidth]="'90px'"
          id="day-column"
          class="table-color border-0 p-0">
          <div class="d-flex align-items-center">
            <div
              class="h-100 w-100 d-flex align-items-center justify-content-center table-color">
              <div
                class="w-100 cell-date text-center"
                [ngClass]="{
                  'last-th': day.is_total,
                  'current-day': day.date == currentDay
                }"
                nz-tooltip
                [nzTooltipTitle]="day.date | date: 'dd-MM-YYYY'"
                nzTooltipPlacement="top">
                {{ day.is_total ? 'Totale' : (day.date | date: 'dd-MM') }}
              </div>
            </div>
          </div>
        </th>
      </tr>
    </thead>

    <tbody [class.readonly-container]="!is_authorized">
      <tr
        *ngFor="let user of data"
        [ngClass]="{
          highlight: highlightedUser === user.id,
          'readonly-container': !is_authorized
        }">
        <th
          [nzWidth]="'150px'"
          nzLeft
          class="table-color p-2 fw-normal"
          id="user-column">
          <span [ngClass]="{ 'highlight-text': highlightedUser === user.id }">
            {{ user.first_name + ' ' + user.last_name }}
            <img
              [matTooltip]="getEndWorkDate(user)"
              *ngIf="isUserHighlighted(user)"
              class="icon ms-2 mb-1"
              src="assets/images/person_cancel.svg"
              alt="delete" />
          </span>
        </th>
        <th
          *ngFor="let item of user?.capacity; let last = last"
          class="px-2"
          id="capacity-column"
          [ngClass]="{
            highlightRow: highlightedUser === user.id,
            'disabled-cell': endWorkDate(user, item.date)
          }">
          <div class="d-flex align-items-center justify-content-center">
            <!-- Input per giorni -->
            <input
              type="number"
              *ngIf="!last"
              class="data-scrum align-items-center cell-input"
              step="1"
              min="0"
              max="8"
              (click)="highlightUser(user.id)"
              (blur)="removeHighlight()"
              (keydown)="blockInvalidKeys($event)"
              [ngClass]="{
                'current-day': item.date === currentDay,
                'normal-day': item.date !== currentDay,
                'disabled-cell':
                  endWorkDate(user, item.date) || last || isLoading
              }"
              [(ngModel)]="item.billing_value"
              [placeholder]="user.is_capacity_per_days.billing_value"
              (ngModelChange)="
                cellValueChangedCapacityForUsers(
                  item.id,
                  item.value,
                  item.billing_value
                )
              "
              [disabled]="
                !is_authorized ||
                endWorkDate(user, item.date) ||
                last ||
                isLoading
              " />
            <!-- Riga per il totale -->
            <input
              *ngIf="last"
              class="data-scrum align-items-center total-hours cell-input"
              [readonly]="last"
              [ngModel]="item.billing_value" />
          </div>
        </th>
      </tr>

      <!-- Riga totale orizzontale -->
      <tr>
        <th
          nzLeft
          class="table-color p-2 table-border-bottom fw-bolder"
          id="total-column">
          Totale
        </th>
        <th
          *ngFor="let item of totalCapacity['Totale']"
          class="px-2"
          id="total-column-row">
          <div class="d-flex justify-content-center align-items-center">
            <nz-input-number
              class="data-scrum align-items-center total-data"
              nzDisabled
              nz-input
              [nzSize]="'small'"
              [ngClass]="{
                'current-day': item.date == currentDay,
                'normal-day': item.date != currentDay
              }"
              [ngModel]="item.billing_value == null ? 0 : item.billing_value">
            </nz-input-number>
          </div>
        </th>
      </tr>
    </tbody>
  </nz-table>
</div>
